module.exports = __webpack_public_path__ + "media/assets/stores/kobo-fc85751bb8738720f80f3c915134e3c7.jpg";